// extracted by mini-css-extract-plugin
export var container = "_1i-0";
export var disabled = "_1i-4";
export var fullWidth = "_1i-3";
export var lined = "_1i-1";
export var selected = "_1i-5";
export var tab = "_1i-2";